<template>
<div>
    <zm-row>
        <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">Bind Topic</zm-button>
    </zm-row>
    <zm-table @selection-change="handleSelectionChange"
    :data="list.slice((pageable.page - 1) * pageable.size, pageable.page * pageable.size)" v-loading="loading">
        <zm-table-column type="selection" width="60px"></zm-table-column>
        <zm-table-column prop="topicName" label="topicName"></zm-table-column>
        <zm-table-column width="160px">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-button size="small" @click="unbindTopics" type="icon" icon="zm-icon-delete" title="unbind topics"></zm-button>
            </template>
            <template slot-scope="scope">
                <zm-button type="icon" icon="zm-icon-delete" @click="unbindTopic([scope.row.topicName])" title="unbind topic"></zm-button>
            </template>
        </zm-table-column>
    </zm-table>
    <div style="text-align: center" class="pagination-wrap">
        <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
            :current-page.sync="pageable.page" :page-size="pageable.size"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            layout="sizes, total, prev, pager, next, jumper"
            :total="list.length">
        </zm-pagination>
    </div>
    <zm-dialog title="Bind Topic" :visible.sync="visible">
        <zm-form>
            <zm-form-item>
                <div slot="label">
                    <tip label="Topics" id="user-producerGroup-topics"></tip>
                </div>
                <zm-select size="small" v-model="topicNames" clearable filterable multiple style="width: 100%">
                    <zm-option v-for="item in topicList" :key="item.id" :value="item.name" :label="item.name"></zm-option>
                </zm-select>
            </zm-form-item>
        </zm-form>
        <div slot="footer" class="dialog-footer">
            <zm-button size="small" @click="visible = false">Cancel</zm-button>
            <zm-button size="small" type="primary" @click="save()" :loading="loading">Save</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import { getTopics } from '@/api'
import { bindGroup, listTopicsByGroup, unbindGroup } from '@/api/group'
import tip from 'components/ToolTip/index'

export default {
  name: 'producerGroupTopic',
  components: {
    tip
  },
  props: ['userName', 'groupName'],
  data () {
    return {
      hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
      topicList: [],
      loading: false,
      list: [],
      visible: false,
      topicNames: [],
      selectedTopics: [],
      pageable: {
                page: 1,
                size: 10,
                total: 0
            }
        }
    },
    created () {
        this.fetchData()
        this.fetchTopics()
    },
    methods: {
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        fetchTopics () {
            getTopics().then(response => {
                this.topicList = response
            })
        },
        handleSelectionChange (val) {
            this.selectedTopics = val
        },
        fetchData () {
            this.loading = true
          listTopicsByGroup(this.userName, this.groupName).then(response => {
            this.loading = false
            if (response) {
              this.list = response.map(item => {
                return {
                  topicName: item
                }
              })
            } else {
              this.list = []
            }
            }).catch(() => {
                this.loading = false
            })
        },
        showCreate () {
            this.topicNames = []
            this.visible = true
        },
        save () {
            if (this.topicNames.length) {
              this.loading = true
              const { userName, groupName, topicNames } = this
              const data = { userName, groupName, topicNames }
              bindGroup(data).then(response => {
                this.fetchData()
                this.$message({
                  message: 'Bind topics success!',
                  type: 'success'
                })
                this.visible = false
              }).catch(() => {
                this.loading = false
              })
            } else {
                this.$message({
                    message: 'Submit error!',
                    type: 'error'
                })
                return false
            }
        },
        unbindTopics () {
            this.topicNames = this.selectedTopics.map(item => {
                return item.topicName
            })
            if (this.topicNames.length) {
                this.unbindTopic(this.topicNames)
            } else {
                this.$message.error('Please select topic')
            }
        },
        unbindTopic (topicNames) {
            this.loading = true
            this.$confirm('This will unbind the topic. Continue?', 'Warning', {
                confirmButtonText: 'Unbind',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
              this.loading = true
              const { userName, groupName } = this
              const data = { userName, groupName, topicNames }
              unbindGroup(data).then(response => {
                this.fetchData()
                this.$message({
                  message: 'Unbind success!',
                  type: 'success'
                })
              }).catch(() => {
                this.loading = false
              })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Unbind canceled'
                })
            })
        }
    }
}
</script>
